import { render, staticRenderFns } from "./UserWizard.vue?vue&type=template&id=33725daa&scoped=true"
import script from "./UserWizard.vue?vue&type=script&lang=js"
export * from "./UserWizard.vue?vue&type=script&lang=js"
import style0 from "./UserWizard.vue?vue&type=style&index=0&id=33725daa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33725daa",
  null
  
)

export default component.exports